import React from 'react';
import { newClusterByCategoryAggregate } from 'service/service';
import ClusterByCategoryBase from './ClusterByCategoryBase';

const ClusterProvisionedByCategory: React.FC = () => {
    return (
        <ClusterByCategoryBase
            breadcrumbName="New Cluster Provisioned By Category"
            tableTitlePrefix="New Clusters"
            serviceFunc={(p) => newClusterByCategoryAggregate({
                startDate: p.startDate,
                endDate: p.endDate,
                sector: p.sector,
                env: p.env,
                location: p.location,
                page: p.page,
                pageSize: p.pageSize,
                selectedDateInString: p.selectedDateInString,
                computeType: p.clusterCategory
            })}
            navigationPath="/databricksADB/clusterProvisionedByCategory_details"
            preserveFilterKey="cluster_provisioned_filters"
            tableType="cluster-provisioned-by-category"
        />
    );
};

export default ClusterProvisionedByCategory;

